import React, { useState, useEffect, useRef } from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';

import LayoutComposer from '../LayoutComposer';

import css from './LayoutSingleColumn.module.css';

// Commonly used layout
const LayoutSingleColumn = props => {
  const {
    className,
    rootClassName,
    mainColumnClassName,
    children,
    topbar: topbarContent,
    footer: footerContent,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const layoutAreas = `
    topbar
    main
    footer
  `;

  const ref = useRef(null);
  const navBarHeight = ref?.current?.clientHeight || 0;

  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const scrollAfterHeader = lastScrollY >= navBarHeight;

  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth > 768) {
      const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
          setIsScrollingUp(false);
          // if (currentScrollY < navBarHeight) {
          //   window.scrollTo(0, navBarHeight);
          // }
        } else {
          setIsScrollingUp(true);
        };

        setLastScrollY(currentScrollY);
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
  }, [lastScrollY]);

  return (
    <LayoutComposer areas={layoutAreas} className={classes} {...rest}>
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
            <Topbar
              ref={ref}
              as="header"
              className={css.topbar}
              style={{
                position: scrollAfterHeader || isScrollingUp ? 'sticky' : 'unset',
                top: isScrollingUp ? 0 : `-${navBarHeight}px`,
                transition: scrollAfterHeader ? 'top 0.4s ease-in-out 0.2s' : '',
                zIndex: 10,
              }}
            >
              {topbarContent}
            </Topbar>
            <Main as="main" className={classNames(css.main, mainColumnClassName)}>
              {children}
            </Main>
            <Footer>{footerContent}</Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

LayoutSingleColumn.displayName = 'LayoutSingleColumn';

LayoutSingleColumn.defaultProps = {
  className: null,
  rootClassName: null,
  footer: null,
};

LayoutSingleColumn.propTypes = {
  className: string,
  rootClassName: string,
  children: node.isRequired,
  topbar: node.isRequired,
  footer: node,
};

export default LayoutSingleColumn;
